/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgPostKargotagOn = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 44.73 44.73">
        <Path class="cls-1" fill='none' stroke='#69c9ca' strokeMiterlimit={10} strokeWidth={2.63} d="M22.23,42.69l.22,0h.06L40.06,12.55a1.75,1.75,0,0,1-.19-.51H4.74a1.58,1.58,0,0,1-.2.32Z" />
        <Path class="cls-1" fill='none' stroke='#69c9ca' strokeMiterlimit={10} strokeWidth={2.63} d="M22.45,12.47a1.83,1.83,0,0,1-.32,0l-8.7,14.91,0,.11,17.53,0a1.57,1.57,0,0,1,.19-.29L22.62,12.46Z" />
        <Circle class="cls-1" fill='none' stroke='#69c9ca' strokeMiterlimit={10} strokeWidth={2.63} cx="22.36" cy="22.36" r="21.05" />
    </Svg>)
}

